/* eslint no-magic-numbers: 0 */
export enum HttpCodes {
    Ok = 200,
    Created = 201,
    NoContent = 204,
    BadRequest = 400,
    Forbidden = 403,
    NotFound = 404,
    Conflict = 409,
    InternalServerError = 500,
}
